module.exports = __webpack_public_path__ + "img/1.2d439814.jpg";